// src/pages/RozgarHami.jsx
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faMoneyBillWave,
  faTasks,
  faHandsHelping,
  faChartLine,
} from "@fortawesome/free-solid-svg-icons";

const RozgarHami = () => {
  const [activeTab, setActiveTab] = useState("EN");

  const content = {
    EN: {
      features: [
        {
          icon: faUsers,
          title: "Guaranteed Employment",
          desc: "Rural households are guaranteed 100 days of wage employment per year through SheEarns digital registration.",
        },
        {
          icon: faMoneyBillWave,
          title: "Direct Wage Payment",
          desc: "Wages are tracked digitally and deposited directly into bank accounts. Unemployment allowance triggers automatically if work is not provided.",
        },
        {
          icon: faTasks,
          title: "Task Management",
          desc: "Rozgar Hami work is assigned and monitored via SheEarns modules like Shakti Daily, Kanban, and Digital Voice Writing.",
        },
        {
          icon: faHandsHelping,
          title: "Community & Social Audit",
          desc: "Women can report delays or issues, and Gram Sabha social audits are digitized for transparency.",
        },
        {
          icon: faChartLine,
          title: "Analytics & Insights",
          desc: "Track workdays, job creation, payments, and identify areas needing additional employment or micro-tasks.",
        },
      ],
      impactStats: [
        { label: "Women Registered", value: "40,00,000–50,00,000" },
        { label: "Workdays Logged", value: "4,00,00,000+" },
        { label: "Micro-Tasks Created", value: "50–100 per village/month" },
        { label: "Additional Jobs via Women SHG Supply Chain", value: "25,000–40,000" },
      ],
      modules: [
        { label: "Digital Income 💰", desc: "Job registration, wage tracking, micro-task assignments." },
        { label: "Digital Learning 💡", desc: "Skill & labor rights training for women." },
        { label: "Task & Management 🗂️", desc: "Assign and monitor Rozgar Hami work digitally." },
        { label: "Community & Social 🤝", desc: "Complaint reporting, awareness campaigns, social audits." },
        { label: "Analytics & Insights 📊", desc: "Track jobs, payments, workdays, and identify gaps for new employment." },
      ],
    },
    MR: {
      features: [
        {
          icon: faUsers,
          title: "गारंटीड रोजगार",
          desc: "ग्रामीण कुटुंबांना SheEarns डिजिटल नोंदणीद्वारे वर्षाला 100 दिवसांचे वेतन रोजगार मिळतो.",
        },
        {
          icon: faMoneyBillWave,
          title: "थेट वेतन देयक",
          desc: "वेतन डिजिटल पद्धतीने ट्रॅक केले जाते आणि थेट बँक खात्यात जमा केले जाते. काम उपलब्ध न झाल्यास बेरोजगारी भत्ता आपोआप लागू होतो.",
        },
        {
          icon: faTasks,
          title: "टास्क व्यवस्थापन",
          desc: "Rozgar Hami काम SheEarns मॉड्यूल्स जसे Shakti Daily, Kanban, आणि Digital Voice Writing द्वारे ट्रॅक केले जाते.",
        },
        {
          icon: faHandsHelping,
          title: "समुदाय आणि सामाजिक ऑडिट",
          desc: "महिला विलंब किंवा समस्या नोंदवू शकतात आणि ग्रामसभा सामाजिक ऑडिट डिजिटल केले जाते.",
        },
        {
          icon: faChartLine,
          title: "अ‍ॅनालिटिक्स आणि अंतर्दृष्टी",
          desc: "कामाचे दिवस, रोजगार निर्मिती, वेतन ट्रॅक करा आणि अतिरिक्त रोजगार आवश्यक असलेल्या क्षेत्रांची ओळख करा.",
        },
      ],
      impactStats: [
        { label: "नोंदणीकृत महिला", value: "40,00,000–50,00,000" },
        { label: "कामाचे दिवस लॉग केले", value: "4,00,00,000+" },
        { label: "मायक्रो-टास्क तयार", value: "प्रति गाव 50–100/महिना" },
        { label: "SHG सप्लाय चेनद्वारे अतिरिक्त नोकऱ्या", value: "25,000–40,000" },
      ],
      modules: [
        { label: "Digital Income 💰", desc: "कामाची नोंदणी, वेतन ट्रॅकिंग, मायक्रो-टास्क्स." },
        { label: "Digital Learning 💡", desc: "महिलांसाठी कौशल्य आणि कामाचे हक्क प्रशिक्षण." },
        { label: "Task & Management 🗂️", desc: "Rozgar Hami काम डिजिटल पद्धतीने व्यवस्थापित करा." },
        { label: "Community & Social 🤝", desc: "तक्रारी नोंदवणे, जागरूकता मोहिमा, सामाजिक ऑडिट्स." },
        { label: "Analytics & Insights 📊", desc: "नोकऱ्या, वेतन, कामाचे दिवस ट्रॅक करा आणि नवीन रोजगारासाठी अंतर ओळखा." },
      ],
    },
  };

  const data = content[activeTab];

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100 p-4">
      {/* Header */}
      <header className="text-center mb-2">
        <h1 className="text-m lg:text-xl font-bold mb-2">
          Maharashtra Rozgar Hami Integration with Think5Whys SAKSHAM Shakti, SAKSHAM Farmer, SAKSHAM Shram Income Augmentation & Job Creation Vision
        </h1>
        <p className="text-gray-400 text-sm lg:text-m">
          Streamlining Maharashtra's Rozgar Hami (MGNREGA) employment for Women with SheEarns, Farmers-Rural with AgriLink and Workers with BlueHands digital modules
        </p>
      </header>

      {/* Tabs */}
      <div className="flex justify-center mb-6 space-x-4">
        <button
          onClick={() => setActiveTab("EN")}
          className={`px-4 py-2 rounded-md font-semibold ${
            activeTab === "EN" ? "bg-indigo-600 text-white" : "bg-gray-800 text-gray-300"
          }`}
        >
          English
        </button>
        <button
          onClick={() => setActiveTab("MR")}
          className={`px-4 py-2 rounded-md font-semibold ${
            activeTab === "MR" ? "bg-indigo-600 text-white" : "bg-gray-800 text-gray-300"
          }`}
        >
          Marathi
        </button>
      </div>

      {/* Features */}
      <section className="mb-2">
        <h2 className="text-m lg:text-lg mb-2">Key Features</h2>
        <div className="grid grid-cols-2 lg:grid-cols-2 gap-1">
          {data.features.map((f, idx) => (
            <div key={idx} className="bg-gray-800 p-4 rounded-lg shadow-md flex items-start gap-3 hover:bg-gray-700 transition">
              <FontAwesomeIcon icon={f.icon} className="text-indigo-400 text-xl" />
              <div>
                <h3 className="font-semibold text-m">{f.title}</h3>
                <p className="text-gray-300 text-sm mt-1">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Impact Stats */}
      <section className="mb-2">
        <h2 className="text-m lg:text-lg font-semibold mb-2">Projected Impact</h2>
        <div className="grid grid-cols-2 lg:grid-cols-2 gap-1">
          {data.impactStats.map((stat, idx) => (
            <div key={idx} className="bg-gray-800 p-4 rounded-lg shadow-md hover:bg-gray-700 transition">
              <h3 className="text-indigo-400 text-lg font-bold">{stat.value}</h3>
              <p className="text-gray-300 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Supporting Modules */}
      <section>
        <h2 className="text-m lg:text-lg font-semibold mb-2">SheEarns Modules Supporting Rozgar Hami</h2>
        <ul className="space-y-1">
          {data.modules.map((mod, idx) => (
            <li key={idx} className="bg-gray-800 p-1 rounded-lg shadow-md hover:bg-gray-700 transition">
              <span className="font-semibold text-indigo-400">{mod.label}:</span> {mod.desc}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default RozgarHami;
